import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import PropTypes from 'prop-types';
import * as Styled from './AudioPlayer.styled';
import { vhFilePropTypes } from '../../../proptypes/Actions';

const AudioPlayer = forwardRef((props, ref) => {
  const audioRef = useRef(null);
  useImperativeHandle(ref, () => ({
    pause: () => {
      if (audioRef && audioRef.current) {
        audioRef.current.pause();
      }
    },
    play: () => {
      console.log('what?/');
      audioRef.current.play();
      if (audioRef && audioRef.current) {
        audioRef.current.play();
      }
    },
  }));
  if (!props.file) {
    console.error('No file provided to audio player');
    return <Styled.AudioPlayer>No file found.</Styled.AudioPlayer>;
  }
  return (
    <Styled.AudioPlayer className={props.className}>
      <audio
        ref={audioRef}
        controls
        onPlay={props.onPlay}
        src={props.file.url}
      />
    </Styled.AudioPlayer>
  );
});

AudioPlayer.propTypes = {
  file: vhFilePropTypes,
  onPlay: PropTypes.func,
};

export default AudioPlayer;
